import React, { useState } from 'react';

import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Tooltip } from 'uiToolkitV1/Tooltip';

const StyledTextWrapper = styled.span`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.linesToShow};
  overflow: hidden;
`;

const TextWithEllipsis = ({ tooltipText = '', linesToShow = 1, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const isEllipsisActive = (containerElement) => containerElement?.offsetHeight < containerElement?.scrollHeight;

  const measuredRef = (node) => {
    if (node !== null) {
      // in node find the child with class name "text-with-ellipsis-tooltip"
      const pTag = node.querySelector('.text-with-ellipsis-tooltip') ?? node?.firstChild?.firstChild;
      setShowTooltip(isEllipsisActive(pTag));
    }
  };

  return (
    <Box ref={measuredRef} sx={{ overflow: 'hidden' }}>
      <Tooltip fontSize="14px" label={tooltipText} isDisabled={!showTooltip} shouldWrapChildren>
        <StyledTextWrapper linesToShow={linesToShow}>{children}</StyledTextWrapper>
      </Tooltip>
    </Box>
  );
};

export default TextWithEllipsis;
